<template>
<div class="home">
    <div class = "notMobile">
        <h2 style="font-family: brother-1816;">이 페이지는 모바일을 기준으로 작성됐습니다.</h2>
        <p>PC, 태블릿 등에서는 요소가 보이지 않거나 제대로 작동하지 않을 수 있습니다.</p>
        <p>PC에서 화면을 움직이려면 크롬에서 <u>F12</u>를 눌러<br />크롬 개발자도구(Chrome DevTools)의 Device Mode를 사용하세요.</p>
    </div>
    <div class = "Mobile">
        <img src="../assets/swipeNext.svg" class="swipeNext">
    </div>
    <img src="../assets/Home1Typo.svg" id="home1Typo">
</div>
</template>

<style scoped>
@media (min-width: 768px) {
  .notMobile {
    visibility: visible !important;
    position: absolute;
    background-color: white;
    z-index:99;
    animation: fadeout 1s;
    animation-fill-mode: forwards;
    animation-delay: 2s;
    width: 500px;
    height: 40vh;
    left: calc((100vw - 500px)/2);
    padding: 20px;
    top: 30vh;
    display:flex;
    align-items:center;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    opacity: 0.8;
  }
}

@keyframes fadeout {
	from {
		opacity: 0.8;
	}
	to {
		opacity: 0;
	}
}

@media (max-width: 768px) {
  .Mobile {
    visibility: visible !important;
    background: rgb(2,0,36);
    background: linear-gradient(0deg, rgba(2,0,36,1) 0%, rgba(12,0,166,0) 100%);
    position: absolute;
    z-index:99;
    animation: fadeinout 3s;
    animation-fill-mode: forwards;
    width: 100vw;
    height: 60vh;
    left: 0px;
    bottom: 0px;
    display:flex;
    align-items:center;
    flex-direction: column-reverse;
    justify-content: center;
    text-align: center;
    opacity: 0;
  }

  .swipeNext {
    position: absolute;
    bottom: 100px;
    width: 60px;
    animation: fadeinoutHand 3s;
    visibility: hidden;
  }
}

@keyframes fadeinout {
	0% {
		opacity: 0;
	}
  35% {
    opacity: 0.7;
  }
	100% {
		opacity: 0;
    visibility: hidden;
    z-index: -1;
	}
}

@keyframes fadeinoutHand {
	10% {
    visibility: visible;
		opacity: 0;
	}
  40% {
    opacity: 1;
  }
	80% {
		opacity: 0;
    visibility: hidden;
    z-index: -1;
	}
}

.Mobile {
  visibility: hidden;
}

.notMobile {
  visibility: hidden;
}

.home {
    background-image: url(../assets/Home1.jpg);
    background-size: cover;
    overflow: hidden;
    height: 100vh;
    background-position: center;
}
#home1Typo {
    width: 218px;
    height: auto;
    position: absolute; 
    left: 20px;
    top: calc(55vh + 10px);
}
</style>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
router.beforeEach(function(to, from, next){
if(from.path == '/' && to.path == '/contact2') {
    to.meta.transition = 'slide-left'
    from.meta.transition = 'slide'
}
else {
    to.meta.transition = 'slide'
}
window.removeEventListener("touchstart",startevent);
window.removeEventListener("touchend", endevent);
next();
});

function startevent(event) {
if(event.touches.length === 1){
    start = event.touches.item(0).clientX;
}else{
    start = null;
}
}

function endevent(event) {
var offset = 100;
if(start){
    var end = event.changedTouches.item(0).clientX;
    if(end > start + offset){
    router.push('/contact2');
    }
    else if(end < start - offset ){
    router.push('/2');
    }
}
}

var start = null;
window.addEventListener("touchstart",startevent);
window.addEventListener("touchend", endevent);
</script>
  